<template>
  <div>
    <el-container direction="vertical">
      <div style="background-color: rgb(255, 255, 255); border: 1px solid #eee;">
        <div>
          <el-form class="form-container listQuery" label-width="80px" :inline="true" style="margin-top: 20px"
            v-loading="formLoading">
            <!-- <el-form-item label="机构">
              <select-tree @input="input"></select-tree>
            </el-form-item> -->
            <el-form-item label="姓名">
              <el-input v-model="listQuery.name"></el-input>
            </el-form-item>
            <!-- <el-form-item label="手机号">
              <el-input v-model="listQuery.phone"></el-input>
            </el-form-item> -->
            <el-form-item label="身份证号">
              <el-input v-model="listQuery.idcard"></el-input>
            </el-form-item>
            <!-- <el-form-item label="责任医师">
              <el-input v-model="listQuery.doctorResponse"></el-input>
            </el-form-item>
            <el-form-item label="出生日期">
              <el-date-picker v-model="birthdayData" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="建档时间">
              <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item> -->
            <el-form-item label="年龄">
              <el-select v-model="agetype" placeholder="请选择">
                <el-option :label="item.label" :value="item.value" v-for="(item, index) in ageList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="糖尿病易患人群">
              <el-select v-model="listQuery.easyillDiabetes" placeholder="请选择">
                <el-option label="全部" :value="null"></el-option>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="规范管理">
              <el-select v-model="listQuery.isDiabetStdManage" placeholder="请选择">
                <el-option label="全部" :value="null"></el-option>
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="margin-left: 40px" @click="submitForm">查询</el-button>
              <!-- <el-button type="primary" @click="addPatient">新建</el-button> -->
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="reportExportToExcel">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table v-loading="listLoading" :data="list" border fit highlight-current-row
          style="width: 100%; margin-left: 0px">
          <el-table-column align="center" label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="性别">
            <template slot-scope="scope">
              <span>{{ getGender(scope.row.gender) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="年龄">
            <template slot-scope="scope">
              <span>{{ getAge(scope.row.birthday) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="电话号码">
            <template slot-scope="scope">
              <span>{{ scope.row.phone }}</span>
            </template>
          </el-table-column>

          <el-table-column width="170px" align="center" label="身份证号">
            <template slot-scope="scope">
              <span>{{ scope.row.idcard }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="标签">
            <template slot-scope="scope">
              <span :class="scope.row.label0">规</span>
              <span :class="scope.row.label1">压</span>
              <span :class="scope.row.label2">脂</span>
              <span :class="scope.row.label3">糖</span>
              <span :class="scope.row.label">糖易</span>
            </template>
          </el-table-column>

          <el-table-column width="200px" align="center" label="操作">
            <template slot-scope="scope">
              <el-button style="margin: 0px" type="text" @click="diabetesAssessmentScoreClick(scope.row)">易患筛查</el-button>
              <el-button style="margin: 2px" type="text" @click="addEhrManage(scope.row)">纳入管理</el-button>
              <el-button style="margin: 0px" type="text" @click="patientsDetail(scope.row)">健康档案</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
          @pagination="turnToPage" />

        <new-add-patient ref="newAddPatientRef" v-if="addPatientVisible" @closeAdd="closeDialog"></new-add-patient>

        <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>

        <patient-record v-if="patientRecordVisible" ref="PatientRecordRef"></patient-record>

        <diabetes-assessment @update="update" v-if="diabetesAssessmentVisible"
          ref="DiabetesAssessmentRef"></diabetes-assessment>
      </div>
    </el-container>
  </div>
</template>
<script>
import {
  getSearchList,
  turnToPageList,
  delPatientList,
  getUserInfos,
  updateEhrManage,
  reportToExcel,
  getSysDicList
} from "@/api/health/Patients";
import Pagination from "@/components/Pagination";
import newAddPatient from "@/views/patient/addPatient";
import patientDetail from "@/views/patient/patientDetail";
import patientRecord from "@/views/patient/patientRecord";
import SelectTree from '@/components/selectTree';
import diabetesAssessment from "./diabetesAssessment";
import { Loading } from "element-ui";
import moment from "moment";

export default {
  components: { Pagination, patientDetail, patientRecord, SelectTree, newAddPatient, diabetesAssessment },
  data() {
    return {
      diabetesAssessmentVisible: false,
      ascvdAssessmentVisible: false,
      data: [],
      list: null,
      total: 0,
      listLoading: false,
      formLoading: false,
      valueData: null,
      birthdayData: null,
      loadingOptions: {
        text: "正在导出...",
        background: "rgba(0, 0, 0, 0.6)",
      },
      listQuery: {
        managerHospitals: [],
        name: null,
        phone: null,
        idcard: null,
        doctorResponse: null,
        birthdayStart: null,
        birthdayEnd: null,
        createTimeStart: null,
        createTimeEnd: null,
        hyperDiabetesRisk: null,
        disease: [],
        isDiabet: "否",
        pageNum: 0,
        pageSize: 10,
        easyillDiabetes: null,
        isDiabetStdManage: null
      },
      managerHospitalList: [],
      patientDetailVisible: false,
      patientRecordVisible: false,
      addPatientVisible: false,
      agetype: null,
      ageList: [
        {
          value: null,
          label: "全部"
        },
        {
          value: 0,
          label: ">35岁"
        },
        {
          value: 1,
          label: "≤35岁"
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      exportBody: {
        url: "/business/ehr/search",
        headers: ['姓名', '性别', '年龄', '电话号码', '身份证号'],
        keys: ["name", "gender", "birthday", "phone", "idcard"],
        body: null,
      },
      sexOptions: []
    };
  },
  created() {
    var typeData = "性别";
    this.getSystemDictList(typeData);
    this.submitForm();
  },
  methods: {
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.sexOptions = records;
      }).catch(err => {
        console.log(err);
      })
    },
    getGender(gender) {
      var option = this.sexOptions.filter(v => v.value == gender)[0];
      return option.name;
    },
    //查询结果导出
    reportExportToExcel() {
      console.log(
        "查询结果导出",
        `表格${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
      );

      let loadingInstance = Loading.service(this.loadingOptions);

      this.exportBody.url = '/business/ehr/search?page=' + this.listQuery.pageNum + '&pageSize=' + this.listQuery.pageSize;

      this.exportBody.body = this.listQuery;
      console.log("导出表格请求body：", this.exportBody);

      reportToExcel(this.exportBody)
        .then((res) => {
          console.log("查询表格导出====", res);

          this.$nextTick(() => {
            loadingInstance.close();
          });

          let blob = new Blob([res], { type: "application/force-download" });
          console.log(blob);
          let fileReader = new FileReader();
          fileReader.readAsDataURL(blob);
          fileReader.onload = (e) => {
            let a = document.createElement("a");
            a.download = `易患人群管理评估表${moment(new Date()).format(
              "YYYYMMDDHHmm"
            )}.xlsx`;
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        })
        .catch((error) => {
          this.$nextTick(() => {
            loadingInstance.close();
          });

          console.log(error);

          this.$message({
            message: "导出失败",
            type: "error",
          });
        });
    },
    // 关闭易患人群筛查表后刷新列表
    update() {
      this.submitForm();
    },
    // 关闭新建弹窗
    closeDialog(value) {
      this.addPatientVisible = value;
    },
    // 新建病人档案
    addPatient() {
      this.addPatientVisible = true;
      var value = this.addPatientVisible;
      this.$nextTick(() => {
        this.$refs.newAddPatientRef.init(value)
      })
      console.log("==============")
    },
    showDiabetesBtn(row) {
      if (row == null || row == "" || row == "否") {
        return true;
      } else {
        return false;
      }
    },
    diabetesAssessmentScoreClick(row) {
      this.diabetesAssessmentVisible = true;
      this.$nextTick(() => {
        this.$refs.DiabetesAssessmentRef.init(row);
      });
    },
    ascvdScoreClick(row) {
      this.$nextTick(() => {
        this.ascvdAssessmentVisible = true;
        this.$refs.ASCVDRef.init(row);
      });
    },
    addEhrManage(row) {
      let params = {
        id: row.id,
        diseases: [{
          name: "糖尿病",
        }],
        diabetDate: this.getSystemTime()
      }
      this.$confirm('此操作将把该患者纳入糖尿病管理, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateEhrManage(params).then(res => {
          if (res.msg == "success") {
            this.$message({
              type: 'success',
              message: '纳入糖尿病管理成功!'
            });
            this.submitForm();
          }
        }).catch((error) => {
          console.log(error);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消纳入糖尿病管理！'
        });
      });
    },
    // 获取系统时间
    getSystemTime() {
      var time = new Date();

      var year = time.getFullYear();
      var month = time.getMonth() + 1;
      var day = time.getDate();

      return year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
    },
    // 获取机构数组
    input(value) {
      this.listQuery.managerHospitals = value;
    },
    setLabel0(value) {
      if (value.isDiabetStdManage == "是") {
        return "labelBlue";
      } else {
        return "labelNone";
      }
    },
    // 获取高血压类名
    setLabel1(value) {
      if (
        value.isBloodpressure == "否" ||
        value.isBloodpressure == null ||
        value.isBloodpressure == ""
      ) {
        this.showLabel1 = false;
        return "labelNone";
      } else {
        this.showLabel1 = true;
        if (
          value.hyerBpRisk == null ||
          value.hyerBpRisk == "0" ||
          value.hyerBpRisk == ""
        ) {
          return "labelGray";
        } else if (value.hyerBpRisk == "1") {
          return "labelGreen";
        } else if (value.hyerBpRisk == "2") {
          return "labelOrange";
        } else if (value.hyerBpRisk == "3") {
          return "labelRed";
        }
      }
    },
    setLabel2(value) {
      if (
        value.isAscvd == "否" ||
        value.isAscvd == null ||
        value.isAscvd == ""
      ) {
        this.showLabel2 = false;
        return "labelNone";
      } else {
        this.showLabel2 = true;
        if (
          value.hyperTcRisk == null ||
          value.hyperTcRisk == "0" ||
          value.hyperTcRisk == ""
        ) {
          return "labelGray";
        } else if (value.hyperTcRisk == "1") {
          return "labelGreen";
        } else if (value.hyperTcRisk == "2") {
          return "labelOrange";
        } else if (value.hyperTcRisk == "3") {
          return "labelRed";
        }
      }
    },
    setLabel3(value) {
      if (
        value.isDiabet == "否" ||
        value.isDiabet == null ||
        value.isDiabet == ""
      ) {
        this.showLabel3 = false;
        return "labelNone";
      } else {
        this.showLabel3 = true;
        if (
          value.hyperDiabetesRisk == null ||
          value.hyperDiabetesRisk == "0" ||
          value.hyperDiabetesRisk == ""
        ) {
          return "labelGray";
        } else if (value.hyperDiabetesRisk == "1") {
          return "labelGreen";
        } else if (value.hyperDiabetesRisk == "2") {
          return "labelOrange";
        } else if (value.hyperDiabetesRisk == "3") {
          return "labelRed";
        }
      }
    },
    // 删除病人档案
    delPatient(value) {
      this.$confirm("此操作将删除该档案信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const patientData = {
            id: value.id,
          };
          this.listLoading = true;
          delPatientList(patientData).then((res) => {
            this.listLoading = false;
            if (res.msg == "success") {
              this.$message({
                message: "删除成功！",
                type: "success",
              });
              // 更新视图列表
              this.turnToPage();
            } else {
              this.$message({
                message: "删除失败！",
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 查询健康列表
    submitForm() {
      this.listLoading = true;
      if (this.valueData != null) {
        this.listQuery.createTimeStart = this.getParseDate(this.valueData[0], 1);
        this.listQuery.createTimeEnd = this.getParseDate(this.valueData[1], 2);
      } else {
        this.listQuery.createTimeStart = null;
        this.listQuery.createTimeEnd = null;
      }
      if (this.birthdayData != null) {
        this.listQuery.birthdayStart = this.getParseDate(this.birthdayData[0], 1);
        this.listQuery.birthdayEnd = this.getParseDate(this.birthdayData[1], 2);
      } else {
        this.listQuery.birthdayStart = null;
        this.listQuery.birthdayEnd = null;
      }
      if (this.agetype == 0) {
        this.listQuery.ageGt = 35;
        this.listQuery.ageLe = null;
      } else if (this.agetype == 1) {
        this.listQuery.ageLe = 35;
        this.listQuery.ageGt = null;
      }

      getSearchList(this.listQuery).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.list = res.data.records;
          this.total = res.data.total;
          this.list.forEach((item, index) => {
            this.list[index].label0 = this.setLabel0(item) ? this.setLabel0(item) : 'labelNone';
            this.list[index].label1 = this.setLabel1(item) ? this.setLabel1(item) : 'labelNone';
            this.list[index].label2 = this.setLabel2(item) ? this.setLabel2(item) : 'labelNone';
            this.list[index].label3 = this.setLabel3(item) ? this.setLabel3(item) : 'labelNone';
            this.list[index].label = this.setLabel(item) ? this.setLabel(item) : 'labelNone';
          })
        }
      });
    },
    // 导航跳转查询列表页
    turnToPage() {
      this.listLoading = true;
      if (this.valueData != null) {
        this.listQuery.createTimeStart = this.getParseDate(this.valueData[0], 1);
        this.listQuery.createTimeEnd = this.getParseDate(this.valueData[1], 2);
      } else {
        this.listQuery.createTimeStart = null;
        this.listQuery.createTimeEnd = null;
      }
      if (this.birthdayData != null) {
        this.listQuery.birthdayStart = this.getParseDate(this.birthdayData[0], 1);
        this.listQuery.birthdayEnd = this.getParseDate(this.birthdayData[1], 2);
      } else {
        this.listQuery.birthdayStart = null;
        this.listQuery.birthdayEnd = null;
      }

      turnToPageList(this.listQuery).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.list = res.data.records;
          this.total = res.data.total;
          // this.list = this.list.filter((item) => {
          //   return item.isDiabet != "是";
          // })
          this.list.forEach((item, index) => {
            this.list[index].label0 = this.setLabel0(item) ? this.setLabel0(item) : 'labelNone';
            this.list[index].label1 = this.setLabel1(item) ? this.setLabel1(item) : 'labelNone';
            this.list[index].label2 = this.setLabel2(item) ? this.setLabel2(item) : 'labelNone';
            this.list[index].label3 = this.setLabel3(item) ? this.setLabel3(item) : 'labelNone';
            this.list[index].label = this.setLabel(item) ? this.setLabel(item) : 'labelNone';
          })
        }
      });
    },
    setLabel(value) {
      if (value.easyillDiabetes) {
        return "labelPurple";
      } else {
        return "labelNone";
      }
    },
    // 跳转至相应病人档案详情页
    patientsDetail(row) {
      this.patientDetailVisible = true;
      this.$nextTick(() => {
        this.$refs["PatientDetailRef"].init(row);
      });
    },
    // 日期格式转化
    getParseDate(time, type) {
      if (type == 1) {
        var newTime = new Date(time);
      } else if (type == 2) {
        var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
      }
      // 获取完整的年份(4位)
      var year = newTime.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = newTime.getMonth() + 1;
      // 获取日期(1-31)
      var date = newTime.getDate();

      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
    },
    // 身份证号加密
    formatIDcard(card) {
      if (card == null) return "";

      var str = card;
      str = str.toString().replace(/^(.{3})(?:\w+)(.{4})$/, "$1***********$2");
      return str;
    },
    // 手机号加密
    formatPhone(card) {
      if (card == null) return "";

      var str = card;
      if (str.length == 11) {
        str = str.toString().replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
        return str;
      } else if (str.length == 8) {
        str =
          str.toString().substring(0, 2) + "****" + str.substr(str.length - 2);
        return str;
      } else {
        return str;
      }
    },
    // 计算当前年龄
    getAge(birthday) {
      if (birthday == null) return "";

      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
  },
};
</script>
<style lang="scss" scoped>
.listQuery {
  display: flex;
  flex-wrap: wrap;
  margin-top: 22px;
}

// .labelRed {
//   border-radius: 50%;
//   color: white;
//   background: red;
//   padding: 3px;
// }

.labelRed {
    height: 24px;
	  width: 24px;
    border-radius: 50%;
    color: white;
    background: red;
    display: inline-block;
}

.labelOrange {
  border-radius: 50%;
  color: white;
  background: orange;
  padding: 3px;
}

.labelGreen {
  border-radius: 50%;
  color: white;
  background: green;
  padding: 3px;
}

.labelGray {
  border-radius: 50%;
  color: white;
  background: gray;
  padding: 3px;
}

.labelBlue {
  border-radius: 50%;
  color: white;
  background: blue;
  padding: 3px;
}

.labelPurple {
  border: 1px solid purple;
  background: purple;
  color: #fff;
  padding: 2px;
  border-radius: 50%;
}

.labelNone {
  display: none;
}

::v-deep .el-form {
  .el-input__inner {
    width: 250px;
  }

  .el-date-editor {
    width: 250px;
  }

  .el-form-item__label {
    width: 120px !important;
  }

  .el-form-item:last-child .el-form-item__content {
    display: flex;
  }
}
</style>
